// Display rows for a totals block, built ONLY from what the server stored
// or returned (order/quote row, or a preview/price response). No pricing
// or tax math happens in the browser — see backend lib/totals.js.
//
// Returns [{ key, label, value, kind }] where kind is one of
// 'line' | 'discount' | 'fee' | 'tax' | 'exempt' | 'total'. Values are
// numbers; the caller formats them.
export function taxLines(src, { includeSubtotal = true, includeTotal = true } = {}) {
  if (!src) return [];
  const n = v => Number(v || 0);
  const rows = [];
  if (includeSubtotal) rows.push({ key: 'subtotal', label: 'Subtotal', value: n(src.subtotal), kind: 'line' });
  if (n(src.discount_amount) > 0) rows.push({ key: 'discount', label: src.discount_percent > 0 ? `Discount (${src.discount_percent}%)` : 'Discount', value: -n(src.discount_amount), kind: 'discount' });
  const delivery = n(src.delivery_fee ?? src.mileage_charge);
  if (delivery > 0) rows.push({ key: 'delivery', label: 'Delivery', value: delivery, kind: 'fee' });
  if (n(src.damage_charge) > 0) rows.push({ key: 'damage', label: 'Damage charge', value: n(src.damage_charge), kind: 'fee' });
  if (n(src.late_fee) > 0) rows.push({ key: 'late', label: src.late_fee_days > 0 ? `Late return fee (${src.late_fee_days} day${src.late_fee_days === 1 ? '' : 's'})` : 'Late fee', value: n(src.late_fee), kind: 'fee' });
  const parts = Array.isArray(src.tax_breakdown) ? src.tax_breakdown : [];
  if (src.tax_exempt) {
    rows.push({ key: 'exempt', label: `Tax exempt${src.tax_exempt_reason ? ` — ${src.tax_exempt_reason}` : ''}`, value: 0, kind: 'exempt' });
  } else if (parts.length) {
    parts.forEach((p, i) => rows.push({ key: `tax-${i}`, label: `${p.name} (${Number(p.rate)}%)`, value: n(p.amount), kind: 'tax' }));
  } else if (n(src.tax_amount) > 0) {
    rows.push({ key: 'tax', label: src.tax_rate ? `Tax (${Number(src.tax_rate)}%)` : 'Tax', value: n(src.tax_amount), kind: 'tax' });
  }
  if (includeTotal) rows.push({ key: 'total', label: 'Total', value: n(src.total), kind: 'total' });
  return rows;
}

export const NO_TAX_WARNING = 'No tax is configured for this business, so orders are being created with $0 tax. Add tax parts in Settings → Tax, or confirm "This business charges no sales tax" there.';
